import { httpClient } from '@/services/axios';
import {defaultResponse} from "@/helpers/functionsHelpers";

const END_POINT = '/api/v1/case/';

class CaseService {
  /**
   * List all cases
   * @param filter
   * @returns {Promise<never>}
   */
  listCases(filter) {
    return httpClient.get(END_POINT.concat(`list/${filter}`)).then((dataResponse) => {
      return defaultResponse(dataResponse);
    });
  }

  queryCase(payload, page = 1) {
    return httpClient.post(END_POINT.concat(`queryCase/${page}`), payload).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * get a all cases data
   * @param case_id
   * @returns {Promise<never>}
   */
  getCase(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/get`)).then((dataResponse) => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * List all users associated to a case
   * @param case_id
   * @returns {Promise<never>}
   */
  listUsers(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/users`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * List all transaction associated to a case
   * @param case_id
   * @returns {Promise<never>}
   */
  listTransactions(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/transactions`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * List all attachments associated to a case
   * @param case_id
   * @returns {Promise<never>}
   */
  listAttachments(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/attachments`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * Function to update patient data like name/cpf/age
   * @param case_id
   * @param patient
   * @returns {Promise<never>}
   */
  updateCasePatient(case_id, patient) {
    return httpClient.post(END_POINT.concat(`${case_id}/update/patient`), patient).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * Function to update observation description on case
   * @param case_id
   * @param observation
   * @returns {Promise<never>}
   */
  updateCaseObservation(case_id, observation) {
    return httpClient.post(END_POINT.concat(`${case_id}/update/obs`), observation).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  updateCaseAddress(case_id, payload) {
    return httpClient.post(END_POINT.concat(`${case_id}/update/address`), payload).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * will change planner on service
   * @param service_id
   * @param payload
   * @returns {Promise<never>}
   */
  changeServicePlanner(service_id, payload) {
    return httpClient.post(END_POINT.concat(`service/${service_id}/setPlanner`), payload).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * getServiceData will get the product service specific data, like Jaw teeth terms of service.
   * @param service_id
   * @returns {Promise<never>}
   */
  getServiceData(service_id) {
    return httpClient.get(END_POINT.concat(`service/${service_id}/get`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * Update service data like tooth marked on Jaw, or extract teeth number...
   * @param case_id
   * @param serviceId
   * @param serviceData
   * @returns {Promise<never>}
   */
  updateServiceData(case_id, serviceId, serviceData) {
    return httpClient.post(END_POINT.concat(`${case_id}/service/${serviceId}/update`), serviceData).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * Submit case to Revising, admin, supervisor and case owner should be allowed to do it
   * @param payload
   * @returns {Promise<never>}
   */
  caseNextFlow(payload) {
    return httpClient.post(END_POINT.concat(`next/${payload.id}`), payload).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  casePreviousFlow(payload) {
    return httpClient.post(END_POINT.concat(`previous/${payload.id}`), payload).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * Review case, admin needs to check if everything is ok, set planners and send case to checkout
   * @param case_id
   * @returns {Promise<never>}
   */
  reviewCase(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/review`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * Archive this case, only admin and supervisor can do it
   * @param case_id
   * @returns {Promise<never>}
   */
  archiveCase(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/archive`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  /**
   * Invalidate backend cache and bring a new fresh object
   * @param case_id
   * @returns {Promise<*>}
   */
  refreshCase(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/refresh`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  markCaseSolved(review_id) {
    return httpClient.get(END_POINT.concat(`review/${review_id}/done`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  addCaseUser(case_id, payload) {
    return httpClient.post(END_POINT.concat(`${case_id}/adduser`), payload).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  deleteCaseUser(case_id, user_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/deleteUser/${user_id}`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  toggleNotification(case_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/toggleNotification`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }

  toggleUserCaseNotification(case_id, user_id) {
    return httpClient.get(END_POINT.concat(`${case_id}/toggleUserNotification/${user_id}`)).then(dataResponse => {
      return defaultResponse(dataResponse);
    });
  }
}

export default new CaseService();
